.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width-250 {
    width: 250px;
  }
}

#tasks-scheduler-date-and-time-section {
  display: flex;
}

#tasks-scheduler-recurrence-section {
  display: block;
}

#tasks-scheduler-recurrence-step-type-field {
  gz-dropdown {
    --form-field-input-width: 138px;
  }
}

.radio {
  display: flex;
  align-items: center;
}

gz-radio {
  margin-right: calc(2 * var(--spacer));
  &#policy-panel-recurrence-schedule-radio {
    width: calc(250px - calc(7 * var(--spacer)));
  }
  &#policy-panel-recurrence-weekdays-radio {
    min-width: 194px;
    margin-bottom: calc(var(--spacer) * 2);
  }
}


.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-checkbox {
  width: auto;
}

gz-radio {
  width: fit-content;
}

.field-with-icon-row {
  display: flex;

  div {
    flex: 0 0 300px;
    display: flex;
  }

  gz-icon {
    margin-bottom: 15px;
  }

  gz-icon + gz-icon {
    margin-left: 5px;
    margin-bottom: 18px;
  }
}
